module.exports = __webpack_public_path__ + "static/media/555f87b4.jpg";